import { render, staticRenderFns } from "./sendmanWalletLog.vue?vue&type=template&id=794f908a&scoped=true&"
import script from "./sendmanWalletLog.vue?vue&type=script&lang=js&"
export * from "./sendmanWalletLog.vue?vue&type=script&lang=js&"
import style0 from "./sendmanWalletLog.vue?vue&type=style&index=0&id=794f908a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f908a",
  null
  
)

export default component.exports